import React from "react"
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from "react-redux"
import { startTest } from "../actions/checks"
import {SelfSpeedCheckButton} from "../checks/SelfSpeed"
import { store } from "../data/store"

function renderSpeedTest(emit) {
    const divEl = document.createElement("div")
    document.body.appendChild(divEl)

    const root = ReactDOMClient.createRoot(divEl)

    const eventHandler = {
        onRegistered: () => {
            console.log("[batchdialer-softphone] registered")
            emit("show")
        },
        onProgress: (status) => {
            console.log("[batchdialer-softphone]", status)
            emit("progress", status)
        },
        onTest: () => {
            console.log("[batchdialer-softphone] disconnected")
            emit("test")
        },
        onFinish: (status) => {
            console.log("[batchdialer-softphone] onFinish", status)
            emit("finished", status)
        },
        onError: error => {
            console.log("[batchdialer-softphone] error ", error)
            emit("error")
        },
    }

    root.render(
        <Provider store={store}>
            <SelfSpeedCheckButton  eventHandler={eventHandler} />
        </Provider>
    )

    return [divEl, root]
}

export default class SpeedTest{
    events = {
        show: [],
        error: [],
        test: [],
        progress: [],
        finished: [],

    }
    container = null
    root = null
    constructor(props) {
        this.emit = this.emit.bind(this)
    }

    on(event, cb) {
        this.events[event].push(cb)
    }

    register() {
        renderSpeedTest(this.emit)
    }
    startTest() {
        store.dispatch(startTest(true))
    }
    progress() {
        store.dispatch(startTest(true))
    }
    stopTest() {
        store.dispatch(startTest(false))
    }
    finished() {
        console.log('test Finished')
    }

    emit(event, value) {
        if (!event && event in this.events[event]) {
            throw Error(event + " is unknown event")
        }

        if (!this.events[event].length) {
            // throw Error(`No callback register for ${event}`);
            console.log(`No callback registerd for ${event}`)
        }
        this.events[event].forEach(cb => cb(value))
    }
}



